import graphql from 'babel-plugin-relay/macro';
import createMutation from '../../helpers/createMutation';

const mutation = graphql`
  mutation UserProfileUpdateMutation($input: User__UpdateInput!) {
    userUpdate(input: $input) {
      user {
        id
        dbId
        firstName
        lastName
        email
      }
      errors {
        attribute
        message
      }
    }
  }
`;

const commit = input =>
    createMutation({
        mutation,
        variables: { input }
    });

export default { commit };
